import { toPrecision } from "./numbers.js";
/**
 * Gets the rotations for the clock hands, with 0deg being 12 o'clock.
 *
 * @param date The date to get the rotations for.
 * @returns The rotations for the clock hands.
 */
export function getClockRotations(date) {
    const secondsPercentage = date.getSeconds() / 60;
    const minutesInSeconds = date.getMinutes() * 60;
    const minutesPercentage = (minutesInSeconds + date.getSeconds()) / (60 * 60);
    const hoursInSeconds = (date.getHours() % 12) * 60 * 60;
    const hoursPercentage = (hoursInSeconds + minutesInSeconds + date.getSeconds()) / (12 * 60 * 60);
    const hours = toPrecision(hoursPercentage * 360, 2);
    const minutes = toPrecision(minutesPercentage * 360, 2);
    const seconds = toPrecision(secondsPercentage * 360, 2);
    return { hours, minutes, seconds };
}
//# sourceMappingURL=clock.js.map